module.exports = __webpack_public_path__ + "img/主播icon.a949c751.png";